<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <v-data-table
        dense
        :headers="headers"
        :items="userGroups"
        :footer-props="{
          'items-per-page-options': [25, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      />
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../functions/format";

export default {
  name: "RestHomeUserGroup",
  data() {
    return {
      headers: [
        { text: "Nome", value: "name" },
        { text: "Descrição", value: "description" },
      ],

      rest_home_id: "",

      userGroups: [],

      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,

    retrieve() {
      const { id } = this.$attrs;

      this.rest_home_id = id;

      this.getUserGroups();
    },
    async getUserGroups(page = 1) {
      try {
        this.loading = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/admin/rest-home/groups/paginate", {
          params,
        });

        const { groups } = response.data;

        this.userGroups = groups;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>